<rs-popup caption="popups.back-to-rockspoon">
  <div class="rs-leave-onboarding">
    <div class="rs-leave-onboarding__content">{{'layout.are-you-sure' | translate}}</div>
    <div class="rs-leave-onboarding__actions">
      <button mat-raised-button color="primary" class="rs-blue-button" tabindex="-1" (click)="goToRockSpoonSite()">{{'buttons.yes' | translate}}</button>
    </div>
  </div>
</rs-popup>
